import { SavedSearch } from '@rygen/rygen-ui/model';

import { OrderSearchCriteria } from './OrderSearchCriteria';

export class OrderSavedSearch extends SavedSearch {
  orderSavedSearchType?: boolean = true;
  searchData?: OrderSearchCriteria;
  searchColumnKeys: string[] = [];

  constructor(opts?: Partial<OrderSavedSearch>) {
    super(opts);

    if (opts?.searchData != null) {
      this.searchData = new OrderSearchCriteria(opts.searchData);
    }
    if (opts?.searchColumnKeys != null) {
      this.searchColumnKeys = opts.searchColumnKeys;
    }
  }

  static isOrderSavedSearch(
    savedSearch: SavedSearch,
  ): savedSearch is OrderSavedSearch {
    return 'orderSavedSearchType' in savedSearch;
  }
}
